import React from 'react'
import OverviewSummaryTable from '../tables/overview-summary/OverviewSummaryTable'
import WorkOrderVehiclesTable from '../tables/work-order-vehicles/WorkOrderVehiclesTable'
import LineItemsTable from '../tables/line-items/LineItemsTable'
import DiscountsTable from '../tables/discounts/DiscountsTable'
import TechniciansTable from '../tables/technicians/TechniciansWoDetailTable'
import CasesTable from '../tables/cases/CasesWoDetailTable'
import WorkOrderHistoryEntriesTable from '../tables/work-order-history-entries/WorkOrderHistoryEntriesTable'
import InvoiceTable from '../tables/invoice/InvoiceTable'
import WorkOrderNotes from '../notes/WorkOrderNotes'
import AdditionalActions from '../work-order-utility/AdditionalActions'
import styles from './styles.module.css'

interface IModalContentProps {
}

export default function ModalContent(props: IModalContentProps) {
  return (
    <>
      <div className={styles.pageTitle}>Work Order Details</div>
      <div className={styles.woDetailsContent}>
        <div className={styles.tablesWrapper}>
          <OverviewSummaryTable />
          <WorkOrderVehiclesTable />
          <LineItemsTable />
          <DiscountsTable />
          <TechniciansTable />
          <CasesTable />
          <WorkOrderHistoryEntriesTable />
          <InvoiceTable />
        </div>
        <div className={styles.sideFlexWrapper}>
          <div className={styles.sideNotesContainer}>
            <WorkOrderNotes />
          </div>
          <div className={styles.sideAdditionalActionsContainer}>
            <AdditionalActions />
          </div>
        </div>
      </div>
    </>
  )
}
